const runner = async () => {
	await window.lodashPromise
	require('./client')
}

runner()
